// Destino del lead del quiz. Módulo aparte, como la medición: quiz.js emite
// quiz:lead y no sabe a dónde va el dato. Cambiar de herramienta es reescribir
// este archivo, no el motor.
//
// QUÉ SE ENVÍA Y POR QUÉ IMPORTA
// La Ley 1581 de 2012 exige poder probar QUÉ texto se autorizó y CUÁNDO. No
// basta un «sí». Por eso el perfil guarda el texto literal del consentimiento
// y su fecha, además del resultado del quiz para poder segmentar después.
//
// El correo NO pasa por el dataLayer (ver quiz-tracking.js). Va directo al
// destino elegido, que es el único autorizado en el texto del consentimiento.

// La tienda protege con hCaptcha el formulario de cliente (/contact con
// form_type=customer). El script de Shopify (captcha-bootstrap) escucha el
// evento submit de esos formularios, consigue el token y solo entonces envía.
// Un fetch directo no pasa por ahí: Shopify respondía 400 y ningún lead del
// quiz llegó a Clientes ni a Probance (comprobado en la tienda el 2026-10-14).
// Por eso se envía un <form> de verdad, invisible, hacia un iframe oculto: pasa
// la misma verificación que el formulario de boletín y la persona no sale del
// quiz. El iframe va con sandbox sin scripts: la página a la que Shopify
// redirige no carga píxeles ni cuenta una visita más.
function enviarFormularioCliente(campos) {
  return new Promise((resolve) => {
    const nombre = `quiz-lead-${Date.now()}`;
    const marco = document.createElement('iframe');
    marco.name = nombre;
    marco.title = 'Envío del cuestionario';
    marco.hidden = true;
    marco.tabIndex = -1;
    marco.setAttribute('aria-hidden', 'true');
    marco.setAttribute('sandbox', 'allow-same-origin');

    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${window.Shopify?.routes?.root || '/'}contact#quiz`;
    form.acceptCharset = 'UTF-8';
    form.target = nombre;
    form.hidden = true;
    Object.entries(campos).forEach(([name, value]) => {
      form.append(Object.assign(document.createElement('input'), { type: 'hidden', name, value }));
    });

    let listo = false;
    const terminar = (ok) => {
      if (listo) return;
      listo = true;
      clearTimeout(espera);
      setTimeout(() => {
        form.remove();
        marco.remove();
      }, 1000);
      resolve(ok);
    };
    // Si la verificación pide resolver un desafío y nadie lo hace, el envío no
    // ocurre: se da por perdido a los 60 s.
    const espera = setTimeout(() => {
      console.warn('[quiz] la verificación de Shopify no terminó; el lead no llegó a Probance');
      terminar(false);
    }, 60000);

    marco.addEventListener('load', () => {
      let url = '';
      try {
        url = marco.contentWindow.location.href;
      } catch {
        /* sin acceso a la respuesta */
      }
      if (!url || url === 'about:blank') return;
      // Shopify redirige con customer_posted=true cuando guarda el contacto.
      const ok = /customer_posted=true/.test(url);
      if (!ok) console.warn('[quiz] Shopify no aceptó el contacto; el lead no llegó a Probance:', url.replace(/\?.*$/, ''));
      terminar(ok);
    });

    document.body.append(marco, form);
    // requestSubmit dispara el evento submit, que es el que intercepta la
    // verificación para pedir el token. form.submit() se lo saltaría.
    const enviar = () => (typeof form.requestSubmit === 'function' ? form.requestSubmit() : form.submit());
    // La verificación solo se engancha a un formulario cuando alguien escribe
    // en él; a uno creado por código hay que engancharla con la función que
    // Shopify publica para eso. Sin ella, el envío se descarta sin avisar.
    const captcha = window.Shopify?.captcha;
    if (typeof captcha?.protect === 'function') captcha.protect(form, enviar);
    else enviar();
  });
}

// Huella corta y estable de un texto (djb2 en base 36): si cambia el texto del
// consentimiento, cambia la huella, y cada etiqueta dice qué versión se aceptó.
function huella(texto) {
  let h = 5381;
  for (const c of String(texto || '')) h = ((h * 33) ^ c.codePointAt(0)) >>> 0;
  return h.toString(36).slice(0, 6);
}

const DESTINOS = {
  /* Probance es el CRM de la tienda. Recibe los contactos igual que el popup
     de boletín del tema (sections/probance-newsletter-popup.liquid): el
     formulario de cliente de Shopify, que crea o marca al cliente como
     suscrito al correo, con etiquetas y los campos PROBANCE_* en la nota.
     Probance sincroniza los clientes de Shopify, así que no abre un flujo de
     datos nuevo. Etiquetas: PROB_QUIZ (origen), quiz-<id> y quiz-rec-<handle>
     para segmentar por quiz y por producto recomendado.

     Prueba del consentimiento (Ley 1581): va en la nota, pero Shopify no
     cambia la nota de un cliente que ya existía; las etiquetas sí se las
     agrega (comprobado en la tienda el 2026-10-15). Por eso también va una
     etiqueta consentimiento-quiz-<versión>-<fecha>: la versión es una huella
     del texto aceptado, que está en docs/quiz/quiz-<id>.json y en Git, y la
     fecha es la del envío. */
  async probance(lead, extra) {
    const etiquetas = [
      'PROB_QUIZ',
      `quiz-${extra.quizId}`,
      extra.recomendado && `quiz-rec-${extra.recomendado}`,
      `consentimiento-quiz-${huella(lead.consent_texto)}-${String(lead.consent_fecha).slice(0, 10)}`,
    ]
      .filter(Boolean)
      .join(', ');
    const campos = {
      form_type: 'customer',
      utf8: '✓',
      'contact[email]': lead.email,
      'contact[tags]': etiquetas,
      'contact[note][PROBANCE_TAGS]': etiquetas,
      'contact[note][PROBANCE_BEGIN]': '###',
      'contact[note][quiz_id]': extra.quizId || '',
      'contact[note][quiz_recomendado]': extra.recomendado || '',
      'contact[note][quiz_consentimiento_texto]': lead.consent_texto,
      'contact[note][quiz_consentimiento_fecha]': lead.consent_fecha,
      'contact[note][PROBANCE_END]': '###',
    };
    if (lead.nombre) campos['contact[first_name]'] = lead.nombre;
    try {
      return await enviarFormularioCliente(campos);
    } catch (error) {
      console.error('[quiz] no se pudo enviar el lead a Probance:', error);
      return false;
    }
  },

  /* Klaviyo: su app embed sigue en el tema, pero la tienda no lo usa como CRM.
     Se deja como alternativa. Soporta el objeto moderno (klaviyo) y el
     antiguo (_learnq). */
  klaviyo(lead, extra) {
    const perfil = {
      $email: lead.email,
      $first_name: lead.nombre,
      $consent: ['email'],
      quiz_id: extra.quizId,
      quiz_fecha: lead.consent_fecha,
      quiz_consentimiento_texto: lead.consent_texto,
      quiz_recomendado: extra.recomendado || null,
      quiz_respondidas: extra.respondidas || null,
      quiz_respuestas: extra.respuestas || null,
    };

    if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
      window.klaviyo.identify(perfil);
      window.klaviyo.push(['track', 'Quiz completado', { quiz_id: extra.quizId, recomendado: extra.recomendado }]);
      return true;
    }
    if (Array.isArray(window._learnq)) {
      window._learnq.push(['identify', perfil]);
      window._learnq.push(['track', 'Quiz completado', { quiz_id: extra.quizId, recomendado: extra.recomendado }]);
      return true;
    }
    console.warn('[quiz] Klaviyo no está disponible en esta página; el lead no se envió');
    return false;
  },

  /* Backend propio. La opción correcta cuando haga falta lógica o guardar en
     una base de datos bajo control, como sugiere AGENTS.md para datos sensibles. */
  async endpoint(lead, extra) {
    if (!extra.endpoint) {
      console.warn('[quiz] destino «endpoint» sin URL configurada; el lead no se envió');
      return false;
    }
    try {
      const r = await fetch(extra.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...lead, quiz_id: extra.quizId, ...extra }),
      });
      return r.ok;
    } catch (error) {
      console.error('[quiz] no se pudo enviar el lead:', error);
      return false;
    }
  },
};

document.addEventListener('quiz:lead', async (event) => {
  const raiz = event.target.closest('[data-quiz]');
  if (!raiz) return;

  const destino = raiz.dataset.quizLeadDestino || 'ninguno';
  if (destino === 'ninguno') {
    console.warn('[quiz] el lead no tiene destino configurado: el correo se está pidiendo y descartando');
    return;
  }

  const fn = DESTINOS[destino];
  if (!fn) return console.warn('[quiz] destino de lead desconocido:', destino);

  const ok = await fn(event.detail.lead, {
    quizId: event.detail.id,
    endpoint: raiz.dataset.quizLeadEndpoint || '',
    recomendado: event.detail.recomendado || null,
    respondidas: event.detail.respondidas || null,
    respuestas: event.detail.respuestas || null,
  });

  raiz.dispatchEvent(
    new CustomEvent('quiz:lead:enviado', { bubbles: true, detail: { destino, ok } }),
  );
});
